import React, { useState } from "react";
import { addHeadTableItem, deleteHeadTableItem } from "../../api/api";
import { useGlobalData } from '../../context/GlobalDataContext';
import "./AdminPanel.css";

const createSlug = (value = "") =>
  String(value)
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");


function LatestTableAdminPanel() {
  const [notification, setNotification] = useState(null);
  const [headItem, setHeadItem] = useState({ label: "Latest Updates", title: "", jobSlug: "" });
  const { headTable = [], threeTable = {}, loading,fetchHeadTable,fetchThreeTable } = useGlobalData();
  const headItems = headTable;
  const jobs = threeTable.jobs || [];
  const admissions = threeTable.admissions || [];
  const [darkMode, setDarkMode] = useState(() => localStorage.getItem('darkMode') === 'true');
  const token = localStorage.getItem("token");
  const role = localStorage.getItem('role');

   React.useEffect(() => {
    if (!headTable?.length) {
      fetchHeadTable();
    }
    if (!threeTable?.jobs?.length && !threeTable?.admissions?.length) {
      fetchThreeTable();
    }
  }, [
    headTable?.length,
    threeTable?.jobs?.length,
    threeTable?.admissions?.length,
    fetchHeadTable,
    fetchThreeTable
  ]);

  React.useEffect(() => {
    const syncDarkMode = () => setDarkMode(localStorage.getItem('darkMode') === 'true');
    window.addEventListener('storage', syncDarkMode);
    window.addEventListener('darkModeChanged', syncDarkMode);
    return () => {
      window.removeEventListener('storage', syncDarkMode);
      window.removeEventListener('darkModeChanged', syncDarkMode);
    };
  }, []);

  const showNotification = (message, type = "success") => {
    setNotification({ message, type });
    setTimeout(() => setNotification(null), 4000);
  };

  // fetching handled by context

  const handleHeadTableSubmit = async (e) => {
    e.preventDefault();
    if (!headItem.title?.trim()) {
      alert("❌ Title is required!");
      return;
    }
    if (!headItem.jobSlug?.trim()) {
      alert("❌ Please select a saved selection job!");
      return;
    }
    if (!token) {
      alert("❌ No token! Please login again.");
      return;
    }
    try {
      const payload = {
        ...headItem,
        slug: `${createSlug(headItem.title)}-${Date.now()}`
      };
      await addHeadTableItem(payload, token);
      const totalCount = headItems.length + 1;
      const successMsg = `✅ "${headItem.title}" added! Total HeadTable items: ${totalCount}`;
      alert(successMsg);
      showNotification(successMsg, "success");
      setHeadItem({ label: headItem.label || "Latest Updates", title: "", jobSlug: "" });
      await fetchHeadTable(); // Refresh head table items after addition
    } catch (err) {
      const errorMsg = err.response?.data?.error || err.message || "Failed to add HeadTable item";
      alert(`❌ Error: ${errorMsg}`);
      showNotification(`❌ ${errorMsg}`, "error");
    }
  };

  const handleDeleteHeadTableItem = async (id, title) => {
    if (window.confirm(`Are you sure you want to delete "${title}" from database?`)) {
      try {
        await deleteHeadTableItem(id, token);
        const remainingCount = headItems.length - 1;
        const deleteMsg = `"${title}" deleted! Remaining items: ${remainingCount}`;
        alert(deleteMsg);
        showNotification(deleteMsg, "success");
        await fetchHeadTable(); // Refresh head table items after deletion
      } catch (err) {
        const errorMsg = err.response?.data?.error || err.message || "Failed to delete item";
        alert(`Error: ${errorMsg}`);
        showNotification(`Error: ${errorMsg}`, "error");
      }
    }
  };

  if (!token) {
    return (
      <div className="admin-panel-error">❌ No token found! Please login first.</div>
    );
  }

  if (role !== 'superadmin') {
    return <div style={{ color: 'red', textAlign: 'center', marginTop: '2rem' }}>Access denied: Superadmin only</div>;
  }

  return (
    <div className={`resource-admin-panel resource-admin-panel--blue${darkMode ? ' dark-mode' : ''}`}> 
      {notification && (
        <div className={`notification notification-${notification.type}`}>
          {notification.message}
        </div>
      )}
      <div className="resource-admin-panel__header">
        <div>
          <h2 className="resource-admin-panel__heading">📊 Latest Table Admin Panel</h2>
          <p className="resource-admin-panel__subtext">Yahan se latest table entries manage karo. Job ya admission select karke entry add karo, list me dekho aur live page open ya delete karo.</p>
        </div>
        <div className="resource-admin-panel__pill">Latest Table</div>
      </div>

      <form className="resource-admin-panel__form" onSubmit={handleHeadTableSubmit}>
        <div className="resource-admin-panel__field">
          <label className="resource-admin-panel__label">Left column label</label>
          <input
            className="resource-admin-panel__input"
            placeholder="Left column label"
            value={headItem.label}
            onChange={(e) => setHeadItem({ ...headItem, label: e.target.value })}
            required
          />
        </div>
        <div className="resource-admin-panel__field">
          <label className="resource-admin-panel__label">Select Job or Admission</label>
          <select
            className="resource-admin-panel__select"
            value={headItem.jobSlug}
            onChange={(e) => setHeadItem({ ...headItem, jobSlug: e.target.value })}
            required
          >
            <option value="">Select Job or Admission</option>
            {jobs.length > 0 && (
              <optgroup label="Jobs">
                {jobs.map((job) => (
                  <option key={job._id} value={job.slug}>
                    {job.title} ({job.slug})
                  </option>
                ))}
              </optgroup>
            )}
            {admissions.length > 0 && (
              <optgroup label="Admissions">
                {admissions.map((admission) => (
                  <option key={admission._id} value={admission.jobSlug || admission.slug}>
                    {admission.title} ({admission.jobSlug || admission.slug})
                  </option>
                ))}
              </optgroup>
            )}
          </select>
        </div>
        <div className="resource-admin-panel__field">
          <label className="resource-admin-panel__label">Moving title</label>
          <input
            className="resource-admin-panel__input"
            placeholder="Moving title"
            value={headItem.title}
            onChange={(e) => setHeadItem({ ...headItem, title: e.target.value })}
            required
          />
        </div>
        <button className="resource-admin-panel__submit" type="submit">➕ Add Latest Table Item</button>
      </form>

      <div className="resource-admin-panel__section">
        <div className="resource-admin-panel__section-top">
          <div>
            <h3 className="resource-admin-panel__section-title">Saved Latest Table Items</h3>
            <p className="resource-admin-panel__section-meta">{headItems.length} items</p>
          </div>
        </div>
        {loading ? <p className="resource-admin-panel__empty">Loading...</p> : headItems.length > 0 ? (
          <div className="resource-admin-panel__list">
            {headItems.map((item) => (
              <div key={item._id} className="resource-admin-panel__item">
                <div>
                  <p className="resource-admin-panel__item-title">{item.title}</p>
                  <p className="resource-admin-panel__item-subtitle">Job: {item.jobTitle || item.jobSlug}</p>
                </div>
                <div className="resource-admin-panel__actions">
                  <a
                    href={`/mform/${item.jobSlug}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="resource-admin-panel__link"
                  >
                    View
                  </a>
                  <button
                    type="button"
                    className="resource-admin-panel__delete"
                    onClick={() => handleDeleteHeadTableItem(item._id, item.title)}
                  >
                    🗑️ Delete
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="resource-admin-panel__empty">No HeadTable items found</p>
        )}
      </div>
    </div>
  );
}

export default LatestTableAdminPanel;
